import React, { useEffect, useState } from "react";
import Header from "../directives/header";
import Footer from "../directives/footer";
import Sidebar from "../directives/sidebar";
import ReactDatatable from '@ashvin27/react-datatable';
import toast, { Toaster } from "react-hot-toast";
import config from "../coreFIles/config";
import Cookies from 'js-cookie'
import {getHrzntlBannerslistAction, HrzntlBannerDeleteAction, HrzntlBannerBlockUnBlockAction } from '../Action/action'
import avt from '../assets/avata_profile.jpg'
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

const loginData = (!Cookies.get('loginSuccessBondiAdmin')) ? [] : JSON.parse(Cookies.get('loginSuccessBondiAdmin'));
const Horizontalbanners = () => {
	const [BannersList, setBannersList] 			= useState([]);
	const [page, setPage] 							= useState(1); 
	const [startIndex, setstartIndex] 				= useState(0);	
	
	useEffect(() => {
		if (!loginData?.email) {
			window.location.href = `${config.baseUrl}login`
		}
		
		getBannerslist(); 
	}, [])
	
	const getBannerslist = async () => {
		let res = await getHrzntlBannerslistAction();
		if (res.success) {
			let data = res.data;
			console.log(data);
			setBannersList(data);	
		}
		else
		{
			setBannersList([]);	
		}
	}
	
	const BannerDelete = async (ad_id) => {
		Swal.fire({
			title: 'Are you sure? ',
			text: "You want to Delete this Horizontal Banner Ad!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
		}).then(async (result) => {
			if (result.isConfirmed) {
				let res = await HrzntlBannerDeleteAction({'ad_id':ad_id});
				if (res.success) {
					getBannerslist();
					Swal.fire(
                        'Deleted!',
                        res.msg,
                        'success'
                    )
				} else {
					Swal.fire(
                        'Failed!',
                        res.msg,
                        'error'
                    )
				}
			}
		});
	}
	
	const columns = [
		{
			key: "Sno.",
			text: "#",
			cell: (row, index) => index + 1,
		},
		{
			key: "ad_title",
			text: "Ad Title"
		},
	
		{
			key: "ad_url",
			text: "Link To",
			cell: (row) => {
				const fullUrl = row.ad_url || '';
				const truncatedUrl = fullUrl.length > 50 ? fullUrl.substring(0, 50) + '...' : fullUrl;
				return (
					<span title={fullUrl}>
						{truncatedUrl}
					</span>
				);
			}
		},
		{
			key: "ad_cat",
			text: "Ad Type",
			cell: (item) => {
				return (
					<>
						{ item.ad_cat === 1 ? 'Personal' : item.ad_cat === 0 ? 'Normal' : '' }
					</>
				)
			}    
		},
		{
			key: "is_center",
			text: "Is Center",
			cell: (item) => {
				return (
					<>
						{ item.is_center === 1 ? 'Yes' : 'No' }
					</>
				)
			}
		},
		{
			key: "status",
			text: "Action",
			cell: (item) => {
				return (
					<>
						<div className="d-flex flex-wrap mb-2" style={{ minWidth: '150px', gap: '4px' }}>
							{ item.status === 0 ?
								<> 
									<button type="button" className="btn btn-danger btn-sm m-1" onClick={() => BannerBlockUnBlock(item.ad_id, 1)}>
										<i className='fa fa-unlock'></i> <span className="d-none d-sm-inline">Inactive</span>
									</button>
									<Link to={`${config.baseUrl}edit-horizontal-baner/` + item.ad_id} className="m-1">
										<button className='btn btn-sm btn-primary'><i className='fa fa-pencil'></i> <span className="d-none d-sm-inline">Edit</span></button>
									</Link>
									<button type="button" className="btn btn-danger btn-sm m-1" onClick={() => BannerDelete(item.ad_id)}>
										<i className='fa fa-trash'></i> <span className="d-none d-sm-inline">Delete</span>
									</button>				   
								</>				
								: item.status === 1 ?
								<>
									<button type="button" className="btn btn-primary btn-sm m-1" onClick={() => BannerBlockUnBlock(item.ad_id, 0)}>
										<i className='fa fa-ban'></i> <span className="d-none d-sm-inline">Active</span>
									</button>
									<Link to={`${config.baseUrl}edit-horizontal-baner/` + item.ad_id} className="m-1">
										<button className='btn btn-sm btn-primary'><i className='fa fa-pencil'></i> <span className="d-none d-sm-inline">Edit</span></button>
									</Link>
									<button type="button" className="btn btn-danger btn-sm m-1" onClick={() => BannerDelete(item.ad_id)}>
										<i className='fa fa-trash'></i> <span className="d-none d-sm-inline">Delete</span>
									</button>				  
								</>				
								:
								'' 
							}
						</div>
					</>
				);
			}
		}
	];
	
	const configForTable = {
		page_size: 10,
		length_menu: [10, 20, 50],
		show_filter: true,
		show_pagination: true,
		pagination: "advance",
		button: {
			excel: false,
			print: false,
		},
	};
	
	
	const BannerBlockUnBlock = async (id, is_active) => {
		Swal.fire({
			title: 'Are you sure?',
			text: is_active == 0 ? "You want to deactivate this horizontal banner ad!”" : "You want to activate this horizontal banner ad!”",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: is_active == 0 ? 'Yes, deactivate it!' : 'Yes, activate it!'
		}).then(async (result) => {
			if (result.isConfirmed) {
			let res = await HrzntlBannerBlockUnBlockAction({ 'id': id, 'is_active': is_active });
				if (res.success) {
					getBannerslist();
					Swal.fire(
						is_active == 0 ? 'Deactivate!' : 'Activate',
						res.msg,
						'success'
					)
				} else {
					Swal.fire(
						'Failed!',
						res.msg,
						'error'
					)
				}
			}
		})
	}
	
	
	return (
		<>
			<div className="wrapper">
				<Header />
				<Toaster />
				<Sidebar />
				
				<div className="content-wrapper">
					<div className="container-full">
						{/* Main content */}
						<div className="content-header">
							<div className="d-flex align-items-center">
								<div className="me-auto">
									<h3 className="page-title mb-3 mb-md-5 pb-2">Horizontal Banner Ads List</h3>
								</div>
							</div>
							<hr />
						</div>
						<section className="content">
							<div className="row">
								<div className="col-lg-12 col-12">
									<div className="box">
										<div className="box-header with-border">
											<div className="row mb-15 align-items-center">
											<h4 className="box-title col-md-6 col-sm-6 col-12 mb-2 mb-md-0">Horizontal Banners ({BannersList.length})</h4>
											<div className="col-md-6 col-sm-6 col-12 text-md-right text-left">
											<a href={`${config.baseUrl}add-horizontal-baner`} className="btn btn-sm btn-primary add_btn">
												<i className='fa fa-plus'></i> Add Horizontal Banner Ads</a>
											</div>
										</div>
										
										</div>
										<div className="box-body">
										<div className="table-responsive" style={{ overflowX: 'auto' }}>
											<ReactDatatable
												config={configForTable}
												records={BannersList}
												columns={columns}
											/>
										</div>
										</div>
									</div>
								</div>
							</div>
						</section>                       
					</div>
				</div>      	
				
				<Footer />
				
			</div>
		</>
	);
}

export default Horizontalbanners;